export const Cockpit_data_admin = [
  {
    id: 1,
    title: 'Vídeos',
    description:
      'Importação de vídeos, adição de informações descritivas e gestão.',
    link_to: 'videos',
    image_link: '/img/navbar_cockpit/videos_icon.svg',
  },
  {
    id: 2,
    title: 'Séries',
    description:
      'Importação de vídeos agrupados em séries, adição de informações descritivas e gestão.',
    link_to: 'series',
    image_link: '/img/navbar_cockpit/series_icon.svg',
  },
  {
    id: 3,
    title: 'Coleções',
    description:
      'Importação de vídeos agrupados, adição de informações descritivas e gestão.',
    link_to: 'colecoes-novo',
    image_link: '/img/navbar_cockpit/colecoes_icon.svg',
  },
  {
    id: 4,
    title: 'Relatórios',
    description: 'Gestão de relatórios de vídeos.',
    link_to: 'relatorios',
    image_link: '/img/navbar_cockpit/relatorio_icon.svg',
  },
  {
    id: 5,
    title: 'Gestão de usuários',
    description:
      'Cadastro e gestão de usuários com atribuição de perfil com associação de unidades e canais.',
    link_to: 'usuarios',
    image_link: '/img/navbar_cockpit/gestao_usuarios_icon.svg',
  },
  {
    id: 6,
    title: 'Home do App',
    description:
      'Configuração dos vídeos e coleções destacados na home do app.',
    link_to: 'aplicativo',
    image_link: '/img/navbar_cockpit/home_app_icon.svg',
  },
  {
    id: 7,
    title: 'Unidades',
    description: 'Gestão de unidades Sesc.',
    link_to: 'unidades',
    image_link: '/img/navbar_cockpit/unidades_sesc_icon.svg',
  },
  {
    id: 8,
    title: 'Canais',
    description: 'Gestão de canais Sesc.',
    link_to: 'canais',
    image_link: '/img/navbar_cockpit/canais_sesc_icon.svg',
  },
  {
    id: 9,
    title: 'Personalidades',
    description: 'Gestão de personalidades associadas as mídias.',
    link_to: 'personalidades',
    image_link: '/img/navbar_cockpit/personalidade_icon.svg',
  },
  {
    id: 10,
    title: 'Palavras-chave',
    description: 'Gestão de palavras-chave associadas as mídias.',
    link_to: 'palavras_chave',
    image_link: '/img/navbar_cockpit/palavras_chave_icon.svg',
  },
];

export const Cockpit_data_gestor = [
  {
    id: 1,
    title: 'Vídeos',
    description:
      'Importação de vídeos, adição de informações descritivas e gestão.',
    link_to: 'videos',
    image_link: '/img/navbar_cockpit/videos_icon.svg',
  },
  {
    id: 2,
    title: 'Séries',
    description:
      'Importação de vídeos agrupados em séries, adição de informações descritivas e gestão.',
    link_to: 'series',
    image_link: '/img/navbar_cockpit/series_icon.svg',
  },
  {
    id: 3,
    title: 'Coleções',
    description:
      'Importação de vídeos agrupados, adição de informações descritivas e gestão.',
    link_to: 'colecoes-novo',
    image_link: '/img/navbar_cockpit/colecoes_icon.svg',
  },
  {
    id: 3,
    title: 'Gestão de usuários',
    description:
      'Cadastro e gestão de usuários com atribuição de perfil com associação de unidades e canais.',
    link_to: 'usuarios',
    image_link: '/img/navbar_cockpit/gestao_usuarios_icon.svg',
  },
];

export const Cockpit_data_editor = [
  {
    id: 1,
    title: 'Vídeos',
    description:
      'Importação de vídeos, adição de informações descritivas e gestão.',
    link_to: 'videos',
    image_link: '/img/navbar_cockpit/videos_icon.svg',
  },
  {
    id: 2,
    title: 'Séries',
    description:
      'Importação de vídeos agrupados em séries, adição de informações descritivas e gestão.',
    link_to: 'series',
    image_link: '/img/navbar_cockpit/series_icon.svg',
  },
  {
    id: 3,
    title: 'Coleções',
    description:
      'Importação de vídeos agrupados, adição de informações descritivas e gestão.',
    link_to: 'colecoes-novo',
    image_link: '/img/navbar_cockpit/colecoes_icon.svg',
  },
];
